import { RouterEffects } from './router.effect';

export const effects = [RouterEffects];

export * from './router.effect';
